const routes = [
    {
        path: '',
        name: 'home',
        component: () => import('@/components/home/Index'),
    },
    {
        path: '/test',
        name: 'test',
        component: () => import('@/components/test/Index'),
    },
    {
        path: '/disclaimer',
        name: 'disclaimer',
        component: () => import('@/components/layouts/Text'),
        props: { content: 'disclaimer' },
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import('@/components/layouts/Text'),
        props: { content: 'privacy' },
    },
    {
        path: '/kanker',
        name: 'homeCancer',
        meta: { theme: 'sand-purple' },
        component: () => import('@/components/home/Index'),
    },
    {
        path: '/kanker/test',
        name: 'testCancer',
        meta: { theme: 'sand-purple' },
        component: () => import('@/components/test/Index'),
    },
    {
        path: '/kanker/disclaimer',
        name: 'disclaimerCancer',
        meta: { theme: 'sand-purple' },
        component: () => import('@/components/layouts/Text'),
        props: { content: 'disclaimer' },
    },
    {
        path: '/kanker/privacy',
        name: 'privacyCancer',
        meta: { theme: 'sand-purple' },
        component: () => import('@/components/layouts/Text'),
        props: { content: 'privacy' },
    },
];

export default routes;
